import { registerAllViews, renderAppShell } from "@org-avp/avp-avengers-ui-app-shell";
import { getElectronAPI } from "@org-avp/avp-avengers-ui-framework-electron-api";
import { initLogIntercept } from "./log-intercept";

const electronAPI = getElectronAPI();
if (electronAPI != null) {
  initLogIntercept(electronAPI);
}

const rootEl = document.getElementById("root");
if (rootEl !== null && rootEl !== undefined) {
  console.log("View registration starting...");
  registerAllViews().then((viewCount) => {
    console.log(`View registration complete (${viewCount} views)`);
    renderAppShell(rootEl);
  });
}
